// extracted by mini-css-extract-plugin
export default {"container":"Top_container__RYRtg","header":"Top_header__MVnuV","title":"Top_title__PuiY-"};